import { IFormField } from '../IForm.types';
import { ItemForm } from './ItemForm';

export class InputStringForm extends ItemForm {
  inputType = 'text';
  inputMask = '';
  placeholder = '';
  spellcheck = true;
  type = 'textfield';
  inputFormat = 'plain';
  style = {
    'margin-left': 'auto',
  };

  constructor(field: IFormField) {
    super(field);
  }
}
